// generated by genversion
module.exports = '2.5.0'
